import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild, SimpleChanges, OnChanges,} from "@angular/core";
import { Store } from '@ngrx/store';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { Observable, take } from 'rxjs';
import { SelectedPlan } from 'src/app/_models/selectedPlan';
import { PrismicService } from 'src/app/_services/prismic.service';
import * as SelectedPlanActions from '../../states/planSelect/selectedPlan.actions';
import brandInfo from '../../../environments/brand.json';
import { MDBModalRef, MDBModalService } from 'ng-uikit-pro-standard';
import { ModalInfoComponent } from 'src/app/modal-info/modal-info.component';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogModalComponent } from 'src/app/mat-dialog-modal/mat-dialog-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { AppConfigService } from '../../appconfig/appconfig.service';
import { resolveFooterDeductible } from 'src/app/_helpers/footer-deductible';

@Component({
  selector: 'app-select-your-plan',
  standalone: false,
  templateUrl: './select-your-plan.component.html',
  styleUrls: ['./select-your-plan.component.scss']
})
export class SelectYourPlanComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() title: any;
  @Input() subTitle: any;
  @Input() plans: any;
  @Input() chosenPlan: any;
  @Input() _deductible: string;
  @Input() select_your_plan_title: any;
  @Input() select_your_plan_subhead: any;
  @Input() refNumber: string;
  @Input() ratesBackground: boolean = false;
  @Output() emitAddToCart = new EventEmitter<string>();
  @Output() marketingPlan = new EventEmitter<any>();

  @ViewChild('slickModal') slickModal: SlickCarouselComponent;
  slickConfig = {};
  plansToDisplay$: Observable<any>;
  plansToDisplay: any;
  preferredLanguage: string;
  currentSlide = 2; // set at -1 to initialize
  currentTimeout = 6000;
  defaultTimeout = 6000; // default
  currentSelectedIndex = 2; // Set default selected index
  paymentPlanCount = 0;
  noFee = '';
  multiDeductible: boolean;
  brand: string;
  paypal: boolean;
  deductible: string;
  /** Pre-formatted currency string for RATES_PAGE.SPLIT_MONTHLY_3 (avoids fragile translate+currency nesting). */
  footerDeductibleDisplay = '';
  /** Pre-formatted currency string for MIXED_CAP_FOOTER (brand fullPayCapAmount threshold). */
  footerCapAmountDisplay = '';
  isWAState: boolean;
  fullPayOnly: boolean;
  allowDiscounts: boolean;
  isFLState: boolean;
  modalRef: MDBModalRef;
  isDrips: boolean;
  branding: any;
  brandInfo: any;
  appFlowState: string;

  constructor(
    private translate: TranslateService,
    private dialog: MatDialog,
    private prismicService: PrismicService,
    private modalService: MDBModalService,
    private store: Store<{ selectedPlan: any }>,
    private appConfig: AppConfigService
  ) {}

  ngAfterContentInit(): void {
    // setTimeout(() => {
      
      if (this.plans?.length) {
        let active = false;
        for (let i = 0; i < this.plans.length; i++) {
          if (this.plans[i].active) {
            active = true;
            this.selectPlan(i);
            break;
          }
        }
      }
    // }}, 1000)
  }

  ngOnInit(): void {
    this.brand = brandInfo.brand;
    this.paypal = brandInfo.paypal;
    this.brandInfo = brandInfo;
    this.appFlowState = sessionStorage.getItem('appFlowState')
    this.isWAState = JSON.parse(sessionStorage.getItem('vehicle')).registeredState === 'WA';
    this.isFLState = JSON.parse(sessionStorage.getItem('vehicle')).registeredState === 'FL';
    this.fullPayOnly = brandInfo.fullPayOnly;
    this.allowDiscounts = brandInfo.allowDiscounts && !this.isFLState && !this.isWAState && brandInfo.brand !== 'HPP' && brandInfo.brand !== 'Genesis'
    this.appConfig.getSettings().subscribe((result) => {
      this.branding = result;
      this.isDrips = this.branding.drips_modal;
    });

    this.slickConfig = {
      autoplay: false,
      dots: false,
      arrows: true,
      infinite: false,
      speed: 1000,
      swipe: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    this.preferredLanguage = sessionStorage.getItem("preferredLanguage") ? sessionStorage.getItem("preferredLanguage") : brandInfo.language;
    this.multiDeductible = brandInfo.multiDeductible;
    this.footerCapAmountDisplay = this.formatUsdWholeAmount(
      Number(this.brandInfo?.fullPayCapAmount),
    );

    this.plansToDisplay$ = this.store.select((store) => store.selectedPlan);
    this.plansToDisplay$.subscribe(val => {
      this.plansToDisplay = val.allPlansPlanBasedTerm;
      this.applyFooterDeductibleFromPlanState(val);
      console.log('VALLLLLLLLL 11', val);
      this.paymentPlanCount = val.currentSelectedPlan ? val.currentSelectedPlan.term.numberOfPayments : 1;
      
      // Adjust card heights when plans data updates
      setTimeout(() => {
        this.adjustCardHeights();
      }, 100);
    });

    if (brandInfo.brand === 'NCESI') {
      if (this.preferredLanguage.indexOf('fr') > -1) {
        this.noFee = 'pas de frais';
      } else {
        this.noFee = 'no fee';
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.refNumber || changes.plans) {
      if (this.refNumber && this.plans?.length) {
        // Handle default plan selection
        const planObj = this.plans.find(
          (plan) => plan.plan.referenceNumber === this.refNumber
        );
        if (planObj) {
          console.log(
            "ngOnChanges: Found default plan, selecting index:",
            this.plans.indexOf(planObj)
          );
          this.selectPlan(this.plans.indexOf(planObj));
        }
      } else if (this.plans?.length && !this.refNumber) {
        // Handle case where no default plan is specified but plans are available
        // Find the first active plan or default to the first plan
        const activePlan =
          this.plans.find((plan) => plan.active) || this.plans[0];
        const planIndex = this.plans.indexOf(activePlan);
        console.log(
          "ngOnChanges: No default plan, selecting first/active plan at index:",
          planIndex
        );
        this.selectPlan(planIndex);
      }
    }
    if (
      changes.refNumber ||
      changes.plans ||
      changes._deductible ||
      changes.chosenPlan
    ) {
      this.store
        .select((s) => s.selectedPlan)
        .pipe(take(1))
        .subscribe((val) => this.applyFooterDeductibleFromPlanState(val));
    }
  }

  breakpoint(e) {
    console.log('breakpoint');
  }
  afterChange(e) {
    console.log('afterChange');
    // Adjust card heights after carousel changes
    setTimeout(() => {
      this.adjustCardHeights();
    }, 100);
  }
  beforeChange(e) {
    console.log('beforeChange:', e.currentSlide);
    this.currentSlide = e.currentSlide;
  }

  nextSlide() {
    this.currentSlide++;
    if (this.currentSlide == this.plans.length) {
      this.currentSlide = 0;
    }
    this.currentTimeout = this.defaultTimeout;
    console.log('slide ', this.currentSlide)
    console.log('timeout ', this.currentTimeout)
  }

  ngAfterViewInit(): void {
    // Go to the current selected index instead of hardcoded slide 2
    if (this.slickModal && this.currentSelectedIndex !== undefined) {
      this.slickModal.slickGoTo(this.currentSelectedIndex);
    }
    
    // Adjust card heights after view is initialized
    setTimeout(() => {
      this.adjustCardHeights();
    }, 100);
  }

  adjustCardHeights(): void {
    if (!this.ratesBackground) return;
    
    const planCards = document.querySelectorAll('.plans-container-cards .plan');
    if (planCards.length === 0) return;
    
    let maxHeight = 0;
    
    // Find the tallest card
    planCards.forEach((card: HTMLElement) => {
      const cardHeight = card.offsetHeight;
      if (cardHeight > maxHeight) {
        maxHeight = cardHeight;
      }
    });
    
    // Set all cards to the same height
    planCards.forEach((card: HTMLElement) => {
      card.style.height = `${maxHeight}px`;
    });
  }

  getHtml(content, vehicleObject) {
    return this.prismicService.getHtml(content, vehicleObject);
  }

  /**
   * Footer used only `term.deductible` from the store; on first paint `currentSelectedPlan` is often the raw
   * API plan without `term.deductible` while `allPlansPlanBasedTerm` / parent `_deductible` already hold the amount.
   */
  private applyFooterDeductibleFromPlanState(val: any): void {
    const raw = resolveFooterDeductible({
      selectedPlanState: val,
      inputDeductible: this._deductible,
      plansInput: this.plans,
      chosenPlan: this.chosenPlan,
    });
    if (raw === null || raw === undefined || raw === '') {
      this.deductible = '';
      this.footerDeductibleDisplay = '';
      return;
    }
    this.deductible = String(raw);
    const n = Number(raw);
    this.footerDeductibleDisplay = Number.isFinite(n)
      ? new Intl.NumberFormat(
          this.localeTagForIntl(),
          {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            // ECMA-402 `narrowSymbol` matches Angular `symbol-narrow`; TS lib omits it from NumberFormatOptions.
            currencyDisplay: 'narrowSymbol',
          } as unknown as Intl.NumberFormatOptions,
        ).format(n)
      : String(raw);
  }

  private localeTagForIntl(): string {
    const pl = this.preferredLanguage || brandInfo.language || 'en-us';
    const parts = pl.split(/[-_]/);
    if (parts.length >= 2) {
      return `${parts[0].toLowerCase()}-${parts[1].toUpperCase()}`;
    }
    return pl;
  }

  /** Plans used for fullPayCapAmount check: store copy when present, else @Input plans. */
  plansForCapCheck(): any[] {
    const fromStore = this.plansToDisplay;
    if (Array.isArray(fromStore) && fromStore.length > 0) {
      return fromStore;
    }
    return Array.isArray(this.plans) ? this.plans : [];
  }

  /** Finite `term.totalPrice` values for displayed plans (for cap-tier footer + card rules). */
  private planTotalPrices(): number[] {
    return this.plansForCapCheck()
      .map((p) => Number(p?.term?.totalPrice))
      .filter((n) => Number.isFinite(n));
  }

  /**
   * Some plan totals strictly below cap (full-pay cards) AND some at or above cap (installment cards).
   * Same threshold as `showInstallmentMessagingForPlan` (`totalPrice >= cap`).
   */
  hasMixedCapPlans(): boolean {
    const cap = Number(this.brandInfo?.fullPayCapAmount ?? 0);
    if (!(cap > 0)) {
      return false;
    }
    const prices = this.planTotalPrices();
    if (prices.length === 0) {
      return false;
    }
    return prices.some((t) => t < cap) && prices.some((t) => t >= cap);
  }

  private formatUsdWholeAmount(n: number): string {
    if (!Number.isFinite(n)) {
      return '';
    }
    return new Intl.NumberFormat(this.localeTagForIntl(), {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      currencyDisplay: 'narrowSymbol',
    } as unknown as Intl.NumberFormatOptions).format(n);
  }

  /**
   * When brand fullPayCapAmount > 0, only show installment/split copy if at least one displayed plan
   * is at or above the cap (same rule as `showInstallmentMessagingForPlan`). Cap 0 preserves legacy behavior.
   */
  showInstallmentMessaging(): boolean {
    const cap = Number(this.brandInfo?.fullPayCapAmount ?? 0);
    if (!(cap > 0)) {
      return true;
    }
    const plans = this.plansForCapCheck();
    if (!plans.length) {
      return false;
    }
    return plans.some((p) => Number(p?.term?.totalPrice) >= cap);
  }

  /**
   * Card-level installment visibility:
   * - cap <= 0: preserve legacy behavior (installment copy on)
   * - cap > 0: plans below cap show full-pay only; plans at/above cap keep installment copy
   */
  showInstallmentMessagingForPlan(plan: any): boolean {
    const cap = Number(this.brandInfo?.fullPayCapAmount ?? 0);
    if (!(cap > 0)) {
      return true;
    }

    const totalPrice = Number(plan?.term?.totalPrice);
    if (!Number.isFinite(totalPrice)) {
      // Keep fallback behavior for unavailable pricing rows.
      return true;
    }

    return totalPrice >= cap;
  }

  selectPlan(index: number): void {
    // Deductible/term pricing is merged into NgRx via SelectedPlanService (allPlansPlanBasedTerm).
    // Parent @Input `plans` is only fully merged for the previously active row, so using it here
    // overwrote currentSelectedPlan with a stale term.deductible when switching cards.
    this.store
      .select((s) => s.selectedPlan)
      .pipe(take(1))
      .subscribe((selectedPlanState) => {
        const fromStore = Array.isArray(selectedPlanState?.allPlansPlanBasedTerm)
          ? selectedPlanState.allPlansPlanBasedTerm[index]
          : null;
        const fromInput = this.plans?.[index];
        const newPlan = (fromStore ?? fromInput) as SelectedPlan;
        if (!newPlan) {
          return;
        }
        this.chosenPlan = newPlan;
        this.currentSelectedIndex = index;

        this.store.dispatch(SelectedPlanActions.loadSelectedPlan({ defaultPlan: newPlan }));
        this.store.dispatch(
          SelectedPlanActions.loadCurrentSelectedPlan({ currentSelectedPlan: newPlan })
        );
      });
  }

  addToCart() {
    console.log("chosenPlan", this.chosenPlan);
    if (this.brand === 'Porsche' && this.chosenPlan.product.productCode === 'POSD') { // Look for the product code !!UPDATE!!
      const title = this.translate.instant('MODAL.TIRE_THREAD_TITLE');
      const content = this.translate.instant('MODAL.TIRE_THREAD_CONTENT');
      const error = this.translate.instant('MODAL.TIRE_ERROR');
      this.showModal(title, content, error, 'yes');
    } else if (this.brand === 'Porsche') { // If the product code is not found assume other product
      const title = this.translate.instant('MODAL.CPO_ELIGIBILITY');
      const content = this.translate.instant('MODAL.CPO_CONTENT');
      const error = this.translate.instant('MODAL.CPO_ERROR');
      this.showModal(title, content, error, 'no');
    } else { // Else send the addToCart event
      this.emitAddToCart.emit("addToCart");
    }
  }

  showModal(title: String, content: String, error: String, accept: String) {
    const dialogRef = this.dialog.open(MatDialogModalComponent, {
      width: '400px',
      panelClass: 'modal-md',
      closeOnNavigation: true,
      disableClose: true,
      data: {
        message: content,
        title: title,
        accept: accept,
        error: error
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.emitAddToCart.emit("addToCart");
      }
    });
  }
}